import lrFullscreenDialog from './_src/lrFullscreenDialog.vue'

lrFullscreenDialog.install = function(Vue) {
  Vue.component(lrFullscreenDialog.name, lrFullscreenDialog)
}

export default lrFullscreenDialog